import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCaptionGenerationCompleted.meta';

export type UseTrackCaptionGenerationCompletedParams = {
  video_id: string;
  duration_seconds: number;
  style_config: string;
};

export const useTrackCaptionGenerationCompleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackCaptionGenerationCompleted = useCallback(
    (params: UseTrackCaptionGenerationCompletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCaptionGenerationCompleted };
};
